// Success Messages.
export const SUCCESS_LOGOUT = 'Successfully logged out!';

// Error Messages.
export const ERROR_GENERAL = 'An internal error occurred. Please try again later.';
